/* FLEXEMA ™ cloned sections — CTA scroll + stat rings */
(function(){
  "use strict";

  function headerOffset(){
    var h = document.querySelector('sticky-header, .header-wrapper, header[role="banner"], .shopify-section-group-header-group');
    var hh = h ? h.getBoundingClientRect().height : 0;
    // Theme sticky header can report a huge phantom height — clamp it.
    if(!hh || hh > 160) hh = 90;
    return hh + 12;
  }

  // Find the buy-box / quantity selector inside the native main-product section.
  function findBuybox(){
    var sels = [
      '.quantity-break',
      '.qty-break', '.quantity_selector',
      '.product-form__buttons', '.product-form',
      'product-info', '.product__info-wrapper', '.product__info-container',
      '[id$="__main"]', '.shopify-section.main-product'
    ];
    for(var i=0;i<sels.length;i++){
      var el = document.querySelector(sels[i]);
      if(el) return el;
    }
    return null;
  }

  function scrollToBuybox(e){
    if(e) e.preventDefault();
    var t = findBuybox();
    if(!t){ return; }
    var y = t.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({top: Math.max(0, y), behavior:'smooth'});
  }

  function bind(){
    document.querySelectorAll('.flx-cta-btn, [data-flx-scroll]').forEach(function(b){
      if(b.__flxBound) return; b.__flxBound = true;
      b.addEventListener('click', scrollToBuybox);
    });
  }

  // Animate stat rings when they enter the viewport.
  function rings(){
    var els = document.querySelectorAll('.flx-stat-ring[data-pct]');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.style.setProperty('--pct', el.getAttribute('data-pct')+'%'); });
      return;
    }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        if(en.isIntersecting){
          en.target.style.setProperty('--pct', en.target.getAttribute('data-pct')+'%');
          io.unobserve(en.target);
        }
      });
    },{threshold:.4});
    els.forEach(function(el){ io.observe(el); });
  }

  // Horizontal arrow carousels
  function carousels(){
    document.querySelectorAll('.flx-carousel').forEach(function(car){
      if(car.__flxCar) return; car.__flxCar = true;
      var track = car.querySelector('.flx-car-track');
      var prev = car.querySelector('.flx-car-prev');
      var next = car.querySelector('.flx-car-next');
      if(!track) return;
      function step(){
        var card = track.firstElementChild;
        var w = card ? card.getBoundingClientRect().width : track.clientWidth*0.8;
        return w + 16;
      }
      function update(){
        var max = track.scrollWidth - track.clientWidth - 2;
        if(prev) prev.disabled = track.scrollLeft <= 2;
        if(next) next.disabled = track.scrollLeft >= max;
      }
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); });
      update();
    });
  }

  function init(){ bind(); rings(); carousels(); }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
